module.exports = __webpack_public_path__ + "media/icons/right-arrow-9429976e.png";